/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Cargando as Cargando,
  rec_DetalleTarea as DetalleTarea,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_GC as GC,
  rec_JSXRuntime as JSXRuntime,
  rec_Nr as Nr,
  rec_Paginacion as Paginacion,
  rec_Qx as Qx,
  rec_React as React,
  rec_Sn as Sn,
  rec_TarjetaTarea as TarjetaTarea,
  rec_Ti as Ti,
  rec_UC as UC,
  rec_WC as WC,
  rec_Yx as Yx,
  rec_Zx as Zx,
  rec_api as api,
  rec_fC as fC,
  rec_fS as fS,
  rec_hS as hS,
  rec_obtenerUsuario as obtenerUsuario,
  rec_usuarioIdSesion as usuarioIdSesion,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function MisTareas() {
  let [e, t] = (0, React.useState)([]),
    [n, r] = (0, React.useState)(0),
    [i, a] = (0, React.useState)(0),
    [o, s] = (0, React.useState)(0),
    [c, l] = (0, React.useState)(!0),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(null),
    [h, g] = (0, React.useState)(null),
    _ = (0, React.useCallback)(async () => {
      (l(!0), f(``));
      try {
        let e = (e) => {
            (t(e.items), a(e.total), n > 0 && e.items.length === 0 && r(n - 1));
          },
          [i, o] = await Promise.all([
            api(`/tareas?mias=true&pagina=${n}&tamano=25`, {
              alRefrescar: e,
            }),
            api(
              `/tareas/pendientes?paginaConformes=0&paginaSolicitudes=0&tamano=1`,
              {
                alRefrescar: (e) =>
                  s(e.conformes.total + e.solicitudesFecha.total),
              },
            ),
          ]);
        (e(i), s(o.conformes.total + o.solicitudesFecha.total));
      } catch (e) {
        f(e.message);
      } finally {
        l(!1);
      }
    }, [n]);
  ((0, React.useEffect)(() => {
    _();
  }, [_]),
    (0, React.useEffect)(() => fC(() => _()), [_]));
  async function v() {
    f(``);
    try {
      let e = obtenerUsuario(),
        t = new URLSearchParams();
      (e?.nombre && t.set(`nombre`, e.nombre),
        e?.correo && t.set(`correo`, e.correo),
        m(await api(`/proyectos/personal?${t.toString()}`)));
    } catch (e) {
      f(e.message);
    }
  }
  return (
    <EstructuraPrincipal
      title={`Mis tareas`}
      children={[
        <div
          className={`flex flex-col gap-6`}
          children={[
            <div
              className={`flex flex-wrap items-center justify-between gap-2`}
              children={[
                <div
                  children={[
                    <p
                      className={`text-base font-medium text-(--text-h)`}
                      children={[UC(), WC() ? `, ${WC()}` : ``]}
                    />,
                    <p
                      className={`text-sm text-(--text)`}
                      children={GC(e, i)}
                    />,
                  ]}
                />,
                <button
                  type={`button`}
                  onClick={v}
                  className={zo}
                  children={[
                    <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                    ` Nueva tarea`,
                  ]}
                />,
              ]}
            />,
            <EstadoError mensaje={u} onReintentar={_} />,
            c ? (
              <Cargando cantidad={5} etiqueta={`Cargando tus tareas`} />
            ) : (
              <JSXRuntime.Fragment
                children={[
                  o > 0 && (
                    <Sn
                      to={`/aprobaciones`}
                      className={`animar-entrada flex flex-wrap items-center gap-2 rounded-2xl border border-(--accent-border) bg-(--accent-bg) p-3 text-sm hover:shadow-(--shadow)`}
                      children={[
                        <Nr className={`h-4 w-4 shrink-0 text-(--accent)`} />,
                        <span
                          className={`min-w-0 flex-1 font-medium text-(--text-h)`}
                          children={[
                            `Tenés `,
                            o,
                            ` `,
                            o === 1 ? `cosa` : `cosas`,
                            ` esperando tu aprobación`,
                          ]}
                        />,
                        <span
                          className={`text-xs text-(--accent)`}
                          children={`Ir a Aprobaciones →`}
                        />,
                      ]}
                    />
                  ),
                  <section
                    className={`flex flex-col gap-2`}
                    children={[
                      <h2
                        className={`text-sm font-semibold uppercase tracking-wide text-(--text)`}
                        children={`Asignadas a ti`}
                      />,
                      e.length === 0 ? (
                        <div
                          className={`animar-entrada flex flex-col items-center gap-3 rounded-2xl border border-dashed border-(--border) p-10 text-center`}
                          children={[
                            <p
                              className={`text-sm text-(--text)`}
                              children={`No tenés tareas asignadas. Cuando alguien te encargue algo, te aparece acá.`}
                            />,
                            <button
                              type={`button`}
                              onClick={v}
                              className={zo}
                              children={[
                                <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                                ` Anotar una tarea`,
                              ]}
                            />,
                          ]}
                        />
                      ) : (
                        <ul
                          className={`grid gap-2 lg:grid-cols-2`}
                          children={e.map((e) => (
                            <li
                              key={e.id}
                              children={
                                <button
                                  type={`button`}
                                  onClick={() => g(e.id)}
                                  className={`animar-entrada w-full rounded-2xl border border-(--border) bg-(--bg) p-3 text-left transition hover:border-(--accent-border)`}
                                  children={[
                                    <div
                                      className={`flex flex-wrap items-center gap-2`}
                                      children={[
                                        <span
                                          className={`min-w-0 flex-1 truncate font-medium text-(--text-h)`}
                                          children={e.titulo}
                                        />,
                                        <span
                                          className={`rounded-full px-2 py-0.5 text-xs ${Zx(e.prioridad)}`}
                                          children={Yx(e.prioridad)}
                                        />,
                                        <span
                                          className={`rounded-full px-2 py-0.5 text-xs ${Qx(e.estado)}`}
                                          children={Yx(e.estado)}
                                        />,
                                      ]}
                                    />,
                                    <div
                                      className={`mt-1 flex flex-wrap items-center gap-3 text-xs text-(--text)`}
                                      children={[
                                        <span
                                          className={`truncate`}
                                          children={hS(e)}
                                        />,
                                        e.fechaVencimiento && (
                                          <span
                                            className={
                                              e.atrasada
                                                ? `font-medium text-(--error)`
                                                : ``
                                            }
                                            children={[
                                              e.atrasada ? `Vencio ` : `Vence `,
                                              ` `,
                                              fS(e.fechaVencimiento),
                                            ]}
                                          />
                                        ),
                                        e.metaTitulo && (
                                          <span
                                            className={`truncate`}
                                            children={[`Meta: `, e.metaTitulo]}
                                          />
                                        ),
                                      ]}
                                    />,
                                  ]}
                                />
                              }
                            />
                          ))}
                        />
                      ),
                      <Paginacion
                        pagina={n}
                        tamano={25}
                        total={i}
                        onChange={r}
                      />,
                    ]}
                  />,
                ]}
              />
            ),
          ]}
        />,
        h && <TarjetaTarea tareaId={h} onClose={() => g(null)} onCambio={_} />,
        p && (
          <DetalleTarea
            proyecto={p}
            preset={{
              asignadoUsuarioId: usuarioIdSesion(),
              asignadoNombre: obtenerUsuario()?.nombre ?? ``,
              asignadoCorreo: obtenerUsuario()?.correo ?? ``,
            }}
            onClose={() => m(null)}
            onGuardado={() => {
              (m(null), _());
            }}
          />
        ),
      ]}
    />
  );
}
